import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Ptag, OverlayLoader } from "components/core";
import SideNav from "components/sideNav";
import SideNavContent from "components/sideNavContent";
import HeaderDasNew from "components/core/headerDasNew";
import backarrow from "assets/images/arrowBack.png";
import creditlogo from "assets/images/green_up_arrow.png";
import debitlogo from "assets/images/green_down_arrow.png";
import { formatAmountWithDecimal, formatDecimalToCSV } from "utlis/utils";
import {
  LongLine,
  ImgHeader,
  BackButton,
  HomeWrapper,
  MessageWrapper,
  Text2,
  TopHeader,
  MsgTag,
  Table,
  EmployeeHeader,
  OuterHeader,
} from "./styles";

const ViewCdTable = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ledgerTable, setLedgerTable] = useState([]);
  const location = useLocation();
  const state = location.state.transactionData;
  const company_name = localStorage.getItem("company_name");
  const business_user_id =
    localStorage.getItem("id") || sessionStorage.getItem("id") || "";
  const showSidebar = () => {
    return !!business_user_id;
  };
  const handleChange = () => {
    navigate("/view_cd_balance");
  };

  const getData = async () => {
    setLoading(true);
    setLedgerTable(state);
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  const getImg = (transaction_status) => {
    const logo = transaction_status === "Credit" ? creditlogo : debitlogo;
    return (
      <img
        style={{
          height: "10px",
          marginRight: "5px",
          textAlign: "top",
          paddingTop: "0",
        }}
        src={logo}
        height="20px"
        width="17px"
      />
    );
  };

  const getTransactionSign = (transaction_status) => {
    return transaction_status === "Credit" ? "+" : "-";
  };

  const renderLedgerTable = () => {
    return (
      <Table>
        <tbody>
          {ledgerTable &&
            ledgerTable.map((individualRow, index) => (
              <tr style={{ borderBottom: "#b01313", height: 48 }}>
                <td>
                  <ImgHeader>
                    {getImg(individualRow.transaction_type)}
                  </ImgHeader>
                </td>
                <td>
                  <OuterHeader>
                    <EmployeeHeader>
                      <Ptag
                        paddingLeft="10px"
                        fontSize="16px"
                        fontWeight="600"
                        minWidth="80%"
                      >
                        {individualRow.action_show}
                      </Ptag>
                      <Ptag paddingLeft="10px" fontSize="12px" fontWeight="400">
                        {individualRow.transaction_date_show}
                      </Ptag>
                    </EmployeeHeader>
                  </OuterHeader>
                </td>
                <td>
                  <TopHeader>
                    <Ptag
                      paddingLeft="10px"
                      fontWeight="600"
                      fontSize="16px"
                      maxLength="80%"
                    >
                      {getTransactionSign(individualRow.transaction_type)} ₹
                      {formatDecimalToCSV(individualRow.transacted_balance)}
                    </Ptag>
                    <Ptag paddingLeft="10px" fontSize="12px" fontWeight="400">
                      Balance ₹
                      {formatDecimalToCSV(individualRow.updated_balance)}
                    </Ptag>
                  </TopHeader>
                </td>
                {/* <LongLine></LongLine>          */}
              </tr>
            ))}
        </tbody>
      </Table>
    );
  };

  const renderNoHistoryMessage = () => {
    return (
      <MsgTag>
        <MessageWrapper>
          <Text2>
            Currently, we do not have any transaction history regarding your CD
            account.
          </Text2>
          <Text2>
            If you have made any recent transactions, please reach out to your
            Account Manager at Vital to get the same updated here.
          </Text2>
        </MessageWrapper>
      </MsgTag>
    );
  };

  const cdLedger = () => {
    return (
      <HomeWrapper>
        <BackButton onClick={handleChange}>
          <img
            style={{ marginRight: "10px" }}
            src={backarrow}
            height="20px"
            width="17px"
          />
          <Ptag fontSize="15px" textAlign="center">
            Back
          </Ptag>
        </BackButton>
        <Ptag fontSize="24px" fontWeight="700">
          Transaction History
        </Ptag>
        <LongLine></LongLine>
        {!(typeof ledgerTable == "string")
          ? renderLedgerTable()
          : renderNoHistoryMessage()}
      </HomeWrapper>
    );
  };

  return (
    <>
      <SideNav>{showSidebar() && <SideNavContent />}</SideNav>
      {loading && <OverlayLoader />}
      <HeaderDasNew company_name={company_name} />
      {cdLedger()}
    </>
  );
};

export default ViewCdTable;
